"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckingAccountFilters = exports.CheckingAccountFiltersProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _utils = require("@navinc/utils");

var checkingAccountFiltersReducer = _interopRequireWildcard(require("./reducer.js"));

var _actions = require("./actions.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var reducer = checkingAccountFiltersReducer["default"],
    selectors = (0, _objectWithoutProperties2["default"])(checkingAccountFiltersReducer, ["default"]);

var _createDomain = (0, _utils.createDomain)({
  domain: 'checkingAccountFilters',
  selectors: selectors,
  actions: {
    fetchCheckingAccountFilters: _actions.fetchCheckingAccountFilters
  },
  reducer: reducer
}),
    _createDomain2 = (0, _slicedToArray2["default"])(_createDomain, 2),
    CheckingAccountFiltersProvider = _createDomain2[0],
    useCheckingAccountFilters = _createDomain2[1];

exports.useCheckingAccountFilters = useCheckingAccountFilters;
exports.CheckingAccountFiltersProvider = CheckingAccountFiltersProvider;
//# sourceMappingURL=use-checking-account-filters.js.map